// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"W7-z","refreshPageWarning":"X7-z","redirectMessageText":"Y7-z"};